export const SET_CUSTOMPRODUCTEDIT_ID = "SET_CUSTOMPRODUCTEDIT_ID";
export const RESET_CUSTOMPRODUCTEDIT_ID = "RESET_CUSTOMPRODUCTEDIT_ID";
export default function (state = {
    input: true,
    id: '',
    keepOpen: false
}, action) {
    switch (action.type) {
        case SET_CUSTOMPRODUCTEDIT_ID: {
            return Object.assign({}, state, {
                id: action.code,
            });
        }
        case RESET_CUSTOMPRODUCTEDIT_ID: {
            return Object.assign({}, state, {
                id: '',
            });
        }
        default:
            return state;
    }
}
